//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum CustomTranslationType {
    Master = 0,
    Custom = 1,
    Conflict = 2,
}

export interface QuizOptionVm {
    id: number;
    guid: string | null;
    customTranslation: CustomTranslationType;
    title: string | null;
    text: string | null;
    resolution: string | null;
    isRight: boolean;
    contentUrl: string | null;
    fillContainer: boolean;
    horizontalAlign: string | null;
    prompt: string | null;
    changePrompt: string | null;
    altText: string | null;
    imageLibrarySearchText: string | null;
}